export default __webpack_public_path__ + "15a75f366774212d807a838b35f9da46.ttf";